import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { type EngagementResponse } from '@backrs_ui/grow-ui/src/redux/coachingAnalytics';

const { coachingAnalytics } = appStrings.modules;

/** The recency and activity pair, which also renders outside this section. */
export const useTopCardsAgentContext = (data: EngagementResponse, visibleMonths: number) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.engagement.recency.title,
    display: 'Donut of login recency bands (last 30 / 31–60 / 61–90 / over 90 days).',
    detail: coachingAnalytics.engagement.recency.info,
    data: data.recently_active,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.engagement.activity.title,
    display: 'Trend lines for student posts, goals and comments.',
    detail: [
      coachingAnalytics.engagement.activity.info,
      'The newest month is still in progress, so it runs low until it closes.',
    ].join('\n\n'),
    data: { series: data.activity.monthly.series.slice(-visibleMonths) },
  });
};

export const useAgentContext = (data: EngagementResponse, networkLimit: number) => {
  useRegisterAgentContext({
    kind: 'section',
    title: coachingAnalytics.engagement.title,
    description: coachingAnalytics.engagement.description,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.engagement.networkMembership.title,
    display: 'Network membership bars ranked by member count.',
    detail: coachingAnalytics.engagement.networkMembership.info(networkLimit),
    data: { networks: data.networks },
  });
};
